import {
  getShouldUseStatesConfigToShowBreakReminder,
  getShouldUseStatesConfigToShowBreakReminderCA,
} from '~/growthbookValue';
import { WorkerClassificationTypeEnum } from '~/models';

/**
 * Allow Contractor and Employee if either:
 * - the current stateLocation allows contractors in statesConfigV2, or
 * - the general statesConfigCAV2 allows contractors.
 * Otherwise, only allow Employee.
 */
export const getIsAllowRestBreak = (
  stateLocation: string,
  workerClassification?: WorkerClassificationTypeEnum,
) => {
  const statesConfigV2 = getShouldUseStatesConfigToShowBreakReminder();
  const statesConfigCAV2 = getShouldUseStatesConfigToShowBreakReminderCA();

  return (
    workerClassification !== undefined &&
    (!!statesConfigV2?.[stateLocation]?.contractor ||
      (stateLocation === 'CA' && !!statesConfigCAV2?.contractor) ||
      workerClassification === WorkerClassificationTypeEnum.Employee)
  );
};
